import React from 'react'
import PropTypes from 'prop-types'

import { Link as RouterLink } from 'react-router-dom'

import {
  AppBar,
  Toolbar,
  Hidden,
  Button,
  IconButton,
  Tooltip,
  makeStyles,
} from '@material-ui/core'

import { Input, Menu, ShoppingCartOutlined } from '@material-ui/icons'

import { routes } from 'routes'
import useAuth from 'hooks/useAuth'
import styles from './styles'

const useStyles = makeStyles(styles)

const Topbar = ({ onSidebarOpen }) => {
  const classes = useStyles()
  const auth = useAuth()
  const mainRoute = auth.checkMainRoute(auth.permissions)

  const handleLogout = () => {
    auth.logout()
  }

  return (
    <AppBar className={classes.root}>
      <Toolbar>
        <RouterLink to={mainRoute} className={classes.logo}>
          <img alt="Logo" src="/images/logos/yapay.svg" width="100%" />
        </RouterLink>

        <div className={classes.flexGrow} />

        <Hidden mdDown>
          <Tooltip title="Checkout de contratação">
            <IconButton
              color="inherit"
              component={RouterLink}
              to={routes.subscribe.main}
              className={classes.checkoutButton}
            >
              <ShoppingCartOutlined />
            </IconButton>
          </Tooltip>

          <Button
            variant="text"
            color="inherit"
            startIcon={<Input />}
            className={classes.logoutButton}
            onClick={handleLogout}
          >
            Sair
          </Button>
        </Hidden>

        <Hidden lgUp>
          <IconButton color="inherit" onClick={onSidebarOpen}>
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  )
}

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
}

export default Topbar
